
/// <reference path="../../../setup/_references.ts" />
module onvio.clientDashboard.ClientAboutComponent {
    'use strict';

    // Controller to manage the display and configuration of the "About"
    // client component.
    export class ClientAboutController {
        public client: cs.IClientWithExpansionV3Dto;
        private contact: cs.IContactWithExpansionV7Dto;

        public isLoading: boolean;
        public onEdit: (client: cs.IClientWithExpansionV3Dto) => void;

        // display bindings
        public primaryAddress: cs.IContactAddressV4Dto;
        public otherAddresses: cs.IContactAddressV4Dto[];
        public status: cs.INamedReferenceDto;
        public entityType: string;

        static $inject = [
            '$translate'
        ];
        constructor(
            private $translate: ng.translate.ITranslateService
        ) { }

        public $onChanges(changes: any) {
            if (changes.client && changes.client.currentValue && changes.client.currentValue.id) {
                this.updateClientData();
            }
        }

        public updateClientData() {
            this.setContact();
            this.setBusinessAddress();

            this.entityType = this.contact.entityType.name;
            this.status = this.client.clientMainExpanded.status;
        }

        private setContact() {
            this.contact = null;
            if (this.client !== undefined) {
                this.contact = this.client.primaryContactExpanded;
            }
        }

        // format and set the business address
        private setBusinessAddress() {
            this.primaryAddress = null;
            let addresses = this.contact.addresses;
            for (let i in addresses) {
                if (addresses[i].isPrimary) {
                    this.primaryAddress = addresses[i];
                }
            }

            this.otherAddresses = _.filter(addresses, (address: cs.IContactAddressV4Dto) => !address.isPrimary);
        }

        private displayAddressPanel(): boolean {
            if (this.contact && this.contact.addresses) {
                let addresses = this.contact.addresses;
                if (addresses.length > 1) {
                    return true;
                } else if (addresses.length === 1) {
                    if (addresses[0].addressLine1 || addresses[0].addressLine2 ||
                        addresses[0].addressLine3 || addresses[0].addressLine4) {
                        return true;
                    }
                }
            }
            return false;
        }

        private getAddressLink(address: cs.IContactAddressV4Dto): string {
            let googleMapsLink = 'http://maps.google.com/maps?q=';
            let addressString = this.formatAddress(address);
            googleMapsLink += addressString;
            googleMapsLink = googleMapsLink.replace(/ /gi, '+');
            return googleMapsLink;
        }

        private formatAddressLine(addressLine: string): string {
            if (addressLine.length > 0) {
                return ' ' + addressLine;
            }
            return '';
        }

        private formatAddress(address: cs.IContactAddressV4Dto): string {
            let addressString = '';

            if (this.contact !== undefined &&
                address !== undefined) {
                addressString += this.formatAddressLine(address.addressLine1);
                addressString += this.formatAddressLine(address.addressLine2);
                addressString += this.formatAddressLine(address.addressLine3);
                addressString += this.formatAddressLine(address.addressLine4);

                // Note: The city/state/postalcode formatting may need country-specific formatting.
                // currently formatting for US addresses.
                var cityStateZip: string = address.city;

                if (address.stateProvince !== undefined) {
                    if (cityStateZip.length > 0) {
                        cityStateZip += ', ';
                    }
                    cityStateZip += address.stateProvince.name;
                }

                if (address.postalCode.length > 0) {
                    if (cityStateZip.length > 0) {
                        cityStateZip += ' ';
                    }
                    cityStateZip += address.postalCode;
                }

                addressString += this.formatAddressLine(cityStateZip);
            }
            return addressString;
        }

        private formatPrimaryString(primary: string): string {
            return `${primary} (${this.$translate.instant('Onvio.Reports.ClientDashboard.Primary')})`;
        }
    }

    export class ClientAboutComponent implements ng.IComponentOptions {
        bindings:any = {
            client: '<',
            isLoading: '<',
            onEdit: '&'
        };
        controller = ClientAboutController;
        templateUrl = 'client-dashboard/components/client-about-component/client-about-component.html';
    }

    angular.module('onvio.clientDashboard.ClientAboutComponent', ['bmProfilePhoto'])
            .component('clientAboutComponent', new ClientAboutComponent());
}
